// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import Image from 'Components/frameworks/image/Image.jsx';

export type TripAdvisorRatingsProps = {
  className?: string,
  counterLabel?: string,
  counterUnit?: string,
  counterValue?: string,
  image?: {},
  subratings: Array<{
    localizedName: string,
    ratingImageUrl: string,
    value: number,
  }>,
};

export function TripAdvisorRatings(props: TripAdvisorRatingsProps) {
  const { className, counterLabel, counterUnit, counterValue, image = {}, subratings = [] } = props;

  if (isEmpty(subratings)) return null;

  return (
    <section className={className}>
      <div className="flex items-center justify-center">
        {!isEmpty(image) ? <Image className="my-1" dontChangeAnything {...image} /> : null}
        <span>&nbsp;</span>
        <p className="reset-paragraph text-base">
          {counterLabel}
          <span> </span>
          <span style={{ color: '#429E96' }}>{[counterValue, counterUnit].join(' ')}</span>
        </p>
      </div>
      <ul style={{ width: 'calc(290rem / 16)' }} className="reset-list mt-8 mx-auto px-1">
        {subratings.map(({ localizedName, ratingImageUrl, value }) => {
          if (isEmpty(subratings[0])) return null;

          return (
            <li
              key={localizedName}
              className="mt-1 mx-auto flex items-center justify-between w-full"
            >
              <span className="leading-one rtl:pr-1">{localizedName}</span>
              <span className="leading-none" style={{ width: '5rem' }}>
                <Image
                  className="w-full"
                  altMsg={value}
                  dontChangeAnything
                  imageUrl={ratingImageUrl}
                  mandatoryWidthAndHeight={{ w: 80, h: 17 }}
                  style={{ maxHeight: '1rem', width: '100%' }}
                />
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
